import { render, staticRenderFns } from "./category-tab.vue?vue&type=template&id=a2ab904e&scoped=true"
import script from "./category-tab.vue?vue&type=script&lang=js"
export * from "./category-tab.vue?vue&type=script&lang=js"
import style0 from "./category-tab.vue?vue&type=style&index=0&id=a2ab904e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ab904e",
  null
  
)

export default component.exports